// extracted by mini-css-extract-plugin
export default {"container":"region-horizontal-card_container__3sRnw"};